import { useEffect } from "react";

// C — screen-capture deterrents for customer accounts (the owner is exempt): the whole app blurs the instant the window loses
// focus or PrintScreen is pressed (and the clipboard image is replaced), DevTools / view-source / save / print shortcuts are
// swallowed, the context menu, text selection and image dragging are off outside form fields, and printing yields a notice page.
const isField = (el) => Boolean(el?.closest?.("input, textarea, select, [contenteditable=''], [contenteditable='true']"));
const DEVTOOLS = new Set(["I", "J", "C", "K"]);

export const useCopyShield = (user) => {
  const on = Boolean(user) && user.role !== "admin";
  useEffect(() => {
    if (!on) return undefined;
    const body = document.body;
    body.classList.add("xp-protect");
    let t;
    const shield = (ms) => { body.classList.add("xp-shield"); clearTimeout(t); if (ms) t = setTimeout(() => body.classList.remove("xp-shield"), ms); };
    const unshield = () => { clearTimeout(t); body.classList.remove("xp-shield"); };
    const onBlur = () => shield(0);
    const onVis = () => (document.hidden ? shield(0) : unshield());
    const onKey = (e) => {
      const k = e.key, mod = e.ctrlKey || e.metaKey;
      if (k === "PrintScreen") { shield(2500); navigator.clipboard?.writeText("Xpattern templates are licensed — screenshots are disabled.").catch(() => {}); e.preventDefault(); return; }
      if (k === "F12" || (mod && e.shiftKey && DEVTOOLS.has(k.toUpperCase())) || (mod && ["u", "s", "p"].includes(k.toLowerCase()))) { e.preventDefault(); e.stopPropagation(); }
    };
    const onMenu = (e) => { if (!isField(e.target)) e.preventDefault(); };
    const onDrag = (e) => { if (e.target?.tagName === "IMG" || e.target?.tagName === "CANVAS" || e.target?.tagName === "svg") e.preventDefault(); };
    window.addEventListener("blur", onBlur);
    window.addEventListener("focus", unshield);
    document.addEventListener("visibilitychange", onVis);
    document.addEventListener("keydown", onKey, true);
    document.addEventListener("keyup", onKey, true);
    document.addEventListener("contextmenu", onMenu);
    document.addEventListener("dragstart", onDrag);
    return () => {
      body.classList.remove("xp-protect", "xp-shield");
      window.removeEventListener("blur", onBlur);
      window.removeEventListener("focus", unshield);
      document.removeEventListener("visibilitychange", onVis);
      document.removeEventListener("keydown", onKey, true);
      document.removeEventListener("keyup", onKey, true);
      document.removeEventListener("contextmenu", onMenu);
      document.removeEventListener("dragstart", onDrag);
    };
  }, [on]);
};
